import Charts from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { MonthlySalesHeading } from "../../../Constant";
import { OPTION_SALES_DATA } from "../../../Data/Widgets/ChartWidgets";

const MonthlySales = () => {
  return (
    <Col xl="5" lg="12" className="xl-50 box-col-6">
      <div className="small-chart-widget chart-widgets-small">
        <Card>
          <CommonCardHeader title={MonthlySalesHeading} className="boeder-bottom-1" />
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col xs="12">
                  <div id="chart-widget8">
                    <Charts options={OPTION_SALES_DATA} series={OPTION_SALES_DATA.series} height={320} type="radar"/>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default MonthlySales;
